import React, {useEffect, useState} from 'react';
import styled from '@emotion/styled';
import TymeLink from '../components/link.js';
import theme from '../design-system/theme';
import {modularScale} from '../design-system/utils';
import ParagraphHeading from "../design-system/typography/paragraph-heading";
import Copy from "../design-system/typography/copy";
import RoundAppButton from "./round-app-button";
import StarIcon from "../assets/review/star.svg"
import ArrowRating from "../assets/review/arrow-rating.svg"
import Heading from "../design-system/typography/heading";
import PageHeading from "../design-system/typography/page-heading";

const ReviewContainer = ({navResources}) => {

    let reviews = navResources.review_snippet.reviews;

    const [currentPage, setCurrentPage] = useState(0);
    const [visibleIndices, setVisibleIndices] = useState([]);
    const [oldVisibleIndices, setOldVisibleIndices] = useState([]);

    const randomizeSlides = () => {
        setOldVisibleIndices(visibleIndices)

        const newIndices = [
            (currentPage * 3) % reviews.length,
            (currentPage * 3 + 1) % reviews.length,
            (currentPage * 3 + 2) % reviews.length
        ];

        setCurrentPage(currentPage + 1);
        setVisibleIndices(newIndices);
    };

    useEffect(() => {
        reviews = reviews.sort(() => Math.random() - 0.5);
        randomizeSlides();
    }, []);

    const styleForSlide = (isVisible) => {
        let style = "ratingContainer smallRatingCopy";
        if (!isVisible) {
            style += " hiddenContainer";
        }
        return style;
    };

    /*
    useEffect(() => {
        const timer = setInterval(() => {
            randomizeSlides();
        }, 10000);

        return () => clearInterval(timer);
    });
     */

    return <StyledReviewContainer>
        <div className="buttonContainer">
            <div className="buttonContainerInner">
                <Heading className="starHeading" componentType={"h4"}>{navResources.review_snippet.title}</Heading>
                <div className="trialButtons">
                    <RoundAppButton
                        className="downloadButton"
                        title={navResources.review_snippet.action}
                        linkTarget={'/download/'}
                        color={"#000000"}
                        big={false}
                    />

                    <RoundAppButton
                        className="pricingButton"
                        title={navResources.pricing}
                        linkTarget={'/pricing/'}
                        color={"#FFFFFF"}
                        big={false}
                    />
                </div>
            </div>
            <div className="ratingContainer">
                <div>
                    <Heading className="starHeading" componentType={"h4"}>4.7</Heading>
                    <img src={StarIcon}/>
                </div>
                <Heading className="starHeading" componentType={"h4"}
                         dangerouslySetInnerHTML={{__html: navResources.review_snippet.app_store_title}}/>
            </div>
        </div>

        <div className="reviewContainers">
            <div className="reviewContainer">
                {
                    visibleIndices.map((index) => <div key={index}
                                                       className={styleForSlide(visibleIndices.includes(index))}>
                        <div>
                            <Heading className="starHeading" componentType={"h4"}>5</Heading>
                            <img src={StarIcon}/>
                        </div>
                        <div dangerouslySetInnerHTML={{__html: reviews[index]}}/>
                    </div>)
                }
            </div>

            <div className="reviewContainer reviewContainerOld">
                {
                    oldVisibleIndices.map((index) => <div key={index}
                                                          className={styleForSlide(!oldVisibleIndices.includes(index))}>
                        <div>
                            <Heading className="starHeading" componentType={"h4"}>5</Heading>
                            <img src={StarIcon}/>
                        </div>
                        <div dangerouslySetInnerHTML={{__html: reviews[index]}}/>
                    </div>)
                }
            </div>

            <button className="nextSlideButton" onClick={randomizeSlides}>
                <img src={ArrowRating}/>
            </button>
        </div>
    </StyledReviewContainer>;
};

const StyledReviewContainer = styled('div')`
    padding: 50px 0 50px 0;

    gap: 20px;
    display: flex;
    flex-direction: column;

    .nextSlideButton {
        position: absolute;
        right: 0;
        top: 0;
        padding: 0;
        margin: 0;
        border: none;
        background: none;
        cursor: pointer;
        border-radius: 0;
    }

    .buttonContainer {
        gap: 20px;
        display: flex;
        flex-direction: column;
    }

    .buttonContainerInner {
        display: flex;
        flex-direction: column;
        gap: 12px;
    }

    .reviewContainers {
        position: relative;
    }

    .reviewContainer {
        gap: 20px;
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }

    .starHeading {
        margin: 0;
    }

    .reviewContainerOld {
        position: absolute;
        top: 0;
        left: 0;
    }

    @media (min-width: ${theme.breakpoints.tablet}px) {
        gap: 40px;
        display: flex;
        flex-direction: column;
        margin-bottom: -50px;

        .buttonContainer {
            gap: 40px;
            display: flex;
            flex-direction: row;
        }

        .reviewContainer {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 40px;
            height: 170px;
        }
    }

    @media (min-width: ${theme.breakpoints.desktop}px) {
        gap: 40px;
        display: flex;
        flex-direction: row;

        .buttonContainer {
            gap: 40px;
            display: flex;
            flex-direction: row;
        }

        .reviewContainer {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 40px;
        }
    }

    .trialButtons {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 20px;
    }

    .downloadButton {
        width: 100%;
    }

    .pricingButton {
        width: 100%;
        color: black;
        border: 2px solid black;
    }

    .ratingContainer {
        display: flex;
        flex-direction: column;
        gap: 12px;

        > div:first-child {
            display: flex;
            flex-direction: row;
            justify-content: left;
            align-items: center;
            gap: 2px;
        }

        opacity: 0;
        animation: fade_in 0.5s ease-in-out 0.5s 1 forwards;
    }

    .hiddenContainer {
        animation: fade_out 0.5s ease-in-out 0.0s 1 forwards;
    }

    @keyframes fade_out {
        0% {
            opacity: 1;
            transform: translate(0);
        }

        100% {
            opacity: 0;
            transform: translate(-100%, 0);
        }
    }

    @keyframes fade_in {
        0% {
            opacity: 0;
            transform: translate(100%, 0);
        }

        100% {
            opacity: 1;
            transform: translate(0);
        }
    }

    .smallRatingCopy {
        > div:last-child {
            font-size: ${modularScale(-1)};
        }
    }
`;

export default ReviewContainer;
